(function(){
  function init(root){
    if(root.__ucp)return;root.__ucp=true;
    var dataEl=root.querySelector('[data-ucp-json]');
    if(!dataEl)return;
    var variants=JSON.parse(dataEl.textContent);
    var form=root.querySelector('form.ucp-form');
    var idInput=root.querySelector('[data-ucp-id]');
    var atc=root.querySelector('[data-ucp-atc]');
    var sticky=root.querySelector('[data-ucp-sticky]');
    var stickyBtn=sticky&&sticky.querySelector('button');
    var slides=root.querySelector('.ucp-slides');
    var dots=root.querySelectorAll('.ucp-dots i');
    var thumbs=root.querySelectorAll('.ucp-thumbs button');
    var cnt=root.querySelector('[data-ucp-cnt]');
    var groups=root.querySelectorAll('[data-ucp-opt]');
    var soldLabel=root.getAttribute('data-sold')||'Sold out';
    var addLabel=root.getAttribute('data-add')||'Add to bag';
    var first=true;
    function selected(){var s=[];groups.forEach(function(g){var c=g.querySelector('input:checked');s.push(c?c.value:null);});return s;}
    function find(sel){if(!groups.length){var cur=idInput&&idInput.value;return variants.find(function(v){return String(v.id)===String(cur);})||variants[0];}return variants.find(function(v){return v.options.every(function(o,i){return o===sel[i];});});}
    function setText(sel,t){root.querySelectorAll(sel).forEach(function(n){n.textContent=t;});}
    function goTo(i){if(!slides)return;var w=slides.clientWidth;slides.scrollTo({left:i*w,behavior:'smooth'});}
    function mark(i){dots.forEach(function(d,k){d.classList.toggle('on',k===i);});thumbs.forEach(function(t,k){t.classList.toggle('on',k===i);});if(cnt)cnt.textContent=(i+1)+' / '+(thumbs.length||dots.length);}
    function availability(){
      var sel=selected();
      groups.forEach(function(g,gi){
        g.querySelectorAll('.ucp-chip').forEach(function(chip){
          var val=chip.querySelector('input').value;
          var ok=variants.some(function(v){return v.available&&v.options[gi]===val&&v.options.every(function(o,i){return i===gi||sel[i]===null||o===sel[i];});});
          chip.classList.toggle('is-out',!ok);
        });
      });
    }
    function update(){
      var v=find(selected());
      availability();
      if(!v){if(atc){atc.disabled=true;atc.textContent='Unavailable';}if(stickyBtn){stickyBtn.disabled=true;}return;}
      if(idInput&&String(idInput.value)!==String(v.id)){idInput.value=v.id;idInput.dispatchEvent(new Event('change',{bubbles:true}));}
      setText('[data-ucp-price]',v.price);
      root.querySelectorAll('[data-ucp-compare]').forEach(function(n){n.textContent=v.compare||'';n.hidden=!v.compare;});
      root.querySelectorAll('[data-ucp-off]').forEach(function(n){n.textContent='-'+v.off+'%';n.hidden=!v.compare;});
      setText('[data-ucp-vtitle]',v.title==='Default Title'?'':' · '+v.title);
      var qty=root.querySelector('[data-ucp-qty]');
      if(qty){qty.hidden=!(v.available&&v.qty===1);}
      var label=v.available?addLabel:soldLabel;
      if(atc){atc.disabled=!v.available;atc.textContent=label;}
      if(stickyBtn){stickyBtn.disabled=!v.available;stickyBtn.textContent=label;}
      if(!first&&root.getAttribute('data-url')==='true'&&window.history&&history.replaceState){var u=new URL(window.location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u);}
      if(!first&&v.media){var el=root.querySelector('.ucp-slide[data-media="'+v.media+'"]');if(el){goTo(Array.prototype.indexOf.call(el.parentNode.children,el));}}
      first=false;
    }
    groups.forEach(function(g){g.addEventListener('change',update);});
    if(slides){
      var tick;
      slides.addEventListener('scroll',function(){clearTimeout(tick);tick=setTimeout(function(){mark(Math.round(slides.scrollLeft/slides.clientWidth));},60);});
      thumbs.forEach(function(t,i){t.addEventListener('click',function(){goTo(i);});});
      dots.forEach(function(d,i){d.addEventListener('click',function(){goTo(i);});});
    }
    if(stickyBtn&&atc){stickyBtn.addEventListener('click',function(){if(form.requestSubmit){form.requestSubmit(atc);}else{atc.click();}});}
    if(sticky&&atc&&'IntersectionObserver' in window){
      new IntersectionObserver(function(es){es.forEach(function(e){sticky.classList.toggle('show',!e.isIntersecting&&e.boundingClientRect.top<0);});}).observe(atc);
    }
    update();
  }
  function boot(){document.querySelectorAll('[data-ucp]').forEach(init);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
  document.addEventListener('shopify:section:load',boot);
})();